import React from 'react';
import { getDecryptedData } from '../../../Utils/LoginUserDetails.js/LoginUserSavedDetails';
import { Box, Typography, Paper, Grid } from '@mui/material';
import BusinessIcon from '@mui/icons-material/Business';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import EmailIcon from '@mui/icons-material/Email';
import PersonIcon from '@mui/icons-material/Person';

const ProviderWelcomeHeader = () => {
  const LoginUserDetails = getDecryptedData();
  
  // Extract details safely
  const {
    fname = '',
    lname = '',
    email = '',
    user_type = '',
    facility = '',
    city = '',
    zip = '',
    street = ''
  } = LoginUserDetails || {};

  // Capitalize first letter of fname & lname
  const capitalize = (text) => text ? text.charAt(0).toUpperCase() + text.slice(1) : '';

  const getTimeGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return 'Good Morning';
    if (hour < 18) return 'Good Afternoon';
    return 'Good Evening';
  };

  return (
    <Paper
      elevation={3}
      sx={{
        padding: '20px',
        background: 'linear-gradient(135deg, #012A4A 0%, #025E73 35%, #028391 65%, #03A9A3 100%)',
        color: 'white',
        borderRadius: '8px',
      }}
    >
      <Grid container spacing={3} alignItems="center">
        {/* Avatar/Icon */}
        <Grid item xs={12} sm={1} display="flex" justifyContent="center">
          <Box
            sx={{
              width: 80,
              height: 80,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              bgcolor: 'white',
              borderRadius: '50%',
            }}
          >
            <PersonIcon sx={{ fontSize: 60, color: '#025E73' }} />
          </Box>
        </Grid>

        {/* Greeting with Name */}
        <Grid item xs={12} sm={3} sx={{ textAlign: 'center' }}>
          <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
            {getTimeGreeting()}, <br /> {capitalize(fname)} {capitalize(lname)}!
          </Typography>
        </Grid>

        {/* User Details */}
        <Grid item xs={12} sm={3} sx={{ textAlign: 'left' }}>
          <Typography variant="body2"><EmailIcon sx={{ verticalAlign: 'middle' }} /> <strong>Email:</strong> {email}</Typography>
          <Typography variant="body2"><BusinessIcon sx={{ verticalAlign: 'middle' }} /> <strong>Facility:</strong> {facility}</Typography>
          <Typography variant="body2"><PersonIcon sx={{ verticalAlign: 'middle' }} /> <strong>Role:</strong> {user_type}</Typography>
        </Grid>

        {/* Address */}
        <Grid item xs={12} sm={4} sx={{ textAlign: 'left' }}>
          <Typography variant="body2"><LocationOnIcon sx={{ verticalAlign: 'middle' }} /> <strong>Address:</strong> {street}, {city} - {zip}</Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default ProviderWelcomeHeader;
